// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"357": "0542da7ac697f95b","757": "4771a27c8c5f1b72",}[chunkId] + ".js"
}